var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Btn',{attrs:{"is-type-icon":"","icon":_vm.icon,"color-icon":_vm.btnColor},on:{"click":_vm.handleClickFavorites}})}
var staticRenderFns = []

export { render, staticRenderFns }